<app-header></app-header>
<div class="container">
    <h2><a href="/" id="home-button">Home</a> > Genesys deck checker</h2>
    <section class="deckInput">
        <label for="decklist">Paste your decklist in plaintext or YDKe format :</label><br>
        <textarea [(ngModel)]="this.decklist" name="decklist" id="decklist" placeholder="Main Deck:
1 Little D
1 Dig Beak
3 Pot of Greed
...

Extra Deck:
1 Gagagigo the Risen


Side Deck:
1 The King of D.
1 Lord of D.

--- OR ---

ydke://5miKAuL6yAFKcEkDSnBJA0pwSQM=!AySKAA==!Ff+IACdwEgE=!
        "></textarea>
        <br>
        <button (click)="displayDeckValues()">Check Points</button><button (click)="resetFields()">Reset</button>
        <h2 id="total">DECK TOTAL: <span class="{{(grandTotal>100) ? 'expensive' : 'cheap'}}">{{ grandTotal }}</span></h2>
    </section>
    
    <section class="results">
        <div *ngFor="let section of resultSections" class="deckSection">
            <h3>{{ section.name }}</h3>
            
            <div *ngFor="let card of section.cards">
                <ng-container *ngIf="card.value !== undefined; else notFound">
                    {{ card.qty }}x <a routerLink="../card/{{this.cleanName(card.name)}}">{{ card.name }}</a> x 
                    <span [ngClass]="card.valueClass">{{ card.value }} pts</span> = <span [ngClass]="card.subtotalClass">{{ card.subtotal }}</span>
                </ng-container>
                <ng-template #notFound>
                    <span class="expensive">{{ card.text }}</span>
                </ng-template>
            </div>
            
            <h3 class="total">Total {{ section.name }}: {{ section.total }}</h3>
        </div>
    </section>
</div>